import React from 'react';
import './CustomerCareTable.css';

const CustomerCareTable = () => {
  const customerCareData = [
    {
      department: 'Sales Department',
      description: 'New Projects, Enquiries',
      contact: '72028 58358',
      icon: 'fas fa-handshake'
    },
    {
      department: 'Customer Complaints',
      description: 'Service issues, After-sales support',
      contact: '95126 00358',
      icon: 'fas fa-headset'
    },
    {
      department: 'HR Admin Department',
      description: 'HR queries, Administrative support',
      contact: '63521 91990',
      icon: 'fas fa-user-tie'
    },
    {
      department: 'Document collection, Mitter File, Subsidy',
      description: 'Document collection, Mitter File, Subsidy',
      contact: '63521 91990',
      icon: 'fas fa-file-alt'
    },
    {
      department: 'Loan & Accounts',
      description: 'Document collection, Payment, Account-related queries',
      contact: '93166 22748',
      icon: 'fas fa-calculator'
    },
    {
      department: 'Material & Installation',
      description: 'Material delivery, Structure, Fitting',
      contact: '70698 10390',
      icon: 'fas fa-tools'
    }
  ];

  return (
    <section className="section customer-care-section">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-badge">
            <i className="fas fa-phone-alt"></i>
            <span>Customer Support</span>
          </div>
          <h2>Customer Care Contact List</h2>
          <p>Contact the right department for faster resolution of your queries</p>
        </div>
        
        <div className="customer-care-table-container">
          <div className="table-responsive">
            <table className="customer-care-table">
              <thead>
                <tr>
                  <th>Department / Concern</th>
                  <th>Description</th>
                  <th>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                {customerCareData.map((item, index) => (
                  <tr key={index}>
                    <td data-label="Department">
                      <div className="department-cell">
                        <div className="department-icon">
                          <i className={item.icon}></i>
                        </div>
                        <span className="department-name">{item.department}</span>
                      </div>
                    </td>
                    <td data-label="Description">
                      <span className="description-text">{item.description}</span>
                    </td>
                    <td data-label="Contact Number">
                      <a href={`tel:+91${item.contact.replace(/\s/g, '')}`} className="contact-link">
                        <i className="fas fa-phone"></i>
                        {item.contact}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Scroll hint for mobile */}
          <div className="scroll-hint">
            <i className="fas fa-hand-point-right"></i>
            Swipe to see more details
          </div>
        </div>

        <div className="customer-care-notes">
          <div className="notes-content">
            <p><strong>Please ensure you contact only the relevant department for faster resolution.</strong></p>
            <p>For urgent issues, you may also report through your assigned project manager.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerCareTable;